export const twilioServer = {
  baseUrl: 'https://callcenter.homesecours.fr/api',
  // baseUrl: 'http://localhost',
};
